import React, { useState, useEffect, useContext } from "react";
import quizThumb from '../assets/images/quiz-default.jpg';
import Header from "../components/dashboard/header";
import Sidebar from "../components/dashboard/sidebar";
import Footer from "../components/footer/Footer";
import SideMenu from "./student/SideMenu";

// import Header from "../components/header/Header";
import { useNavigate, Link, useLocation, useParams } from "react-router-dom";
import moment from "moment";
import tmdbApi from "../api/tmdbApi";
import Select from 'react-select';
import SweetAlert from 'react-bootstrap-sweetalert';
import parse from "react-html-parser";
import DataTable from 'react-data-table-component';
import { contentContext } from "../context/contentContext";
import TableLoader from "../components/tableLoader";
import Loader from "../components/loader";
import Modal from 'react-bootstrap/Modal';
const History = () => {
    const navigate = useNavigate();
    const { state } = useLocation();
    let { id } = useParams();
    const { searchedFlag, setSearchedFlag, isLoading, setIsLoading, processObject, sortTableAlpha, arrow, sortTableByDate, userData, companysearch, setCompanySearch, companyadvSearch, setCompanyAdvSearch, currentPage, setcurrentPage, data, setData, rowsPerPage, setRowsPerPage, currentPageNew, setCurrentPage, route, setRoute, usePrevious, setActiveMenuId, setActiveMenuObj, GetTimeActivity } = useContext(contentContext)
    const [activeTooltip, setActiveTooltip] = useState(null);
    const location = useLocation();
    const moduleType = location.state?.moduleType || null;

    const { quizResult, quizinfo, formData } = state || {};
    const [viewResult, setViewresult] = useState(false);
    const [selected, setSelected] = useState({});
    const [questions, setQuestions] = useState([]);
    const [qdisplay, setQdisplay] = useState(false);
    const [answersdata, setAnswers] = useState([]);
    const [quizData, setQuizData] = useState(null);
    const [items, setItems] = useState([]);
    const [success, setSuccess] = useState(false);
    const [imageCloudfront, setImg] = useState(false);
    const [contentLoaded, setcontentLoaded] = useState(true);
    const [quizzes, setQuizzes] = useState([]);
    const [quizResultData, setQuizResultData] = useState({});

    const keyForRerender = `${rowsPerPage}_${data?.length}`;

    //     useEffect(() => {
    //         if (!localStorage.getItem("token1")) {
    // navigate("/login");
    //         }
    //     }, [])
    // useEffect(() => {
    //   if (!viewResult) return; // only when modal is open

    //   const timer = setTimeout(() => {
    //     const buttons = document.querySelectorAll(".check-answer-btn");

    //     buttons.forEach((btn) => {
    //       const tooltipId = btn.getAttribute("data-tooltip");
    //       const tooltip = document.getElementById(tooltipId);

    //       if (!tooltip) return;

    //       tooltip.style.display = "none";

    //       const toggleTooltip = () => {
    //         const isHidden = tooltip.style.display === "none";
    //         tooltip.style.display = isHidden ? "inline-block" : "none";

    //         console.log(
    //           `Tooltip ${tooltipId} is now ${isHidden ? "OPENED" : "CLOSED"}`
    //         );
    //       };

    //       btn.addEventListener("click", toggleTooltip);

    //       // cleanup
    //       btn._cleanup = () => btn.removeEventListener("click", toggleTooltip);
    //     });
    //   }, 0); // run after DOM paints

    //   return () => {
    //     clearTimeout(timer);
    //     document
    //       .querySelectorAll(".check-answer-btn")
    //       .forEach((btn) => btn._cleanup && btn._cleanup());
    //   };
    // }, [viewResult]);

    useEffect(() => {

        if (window.site === undefined) {
            setTimeout(() => {
                if (window.site && window.site.common && window.site.common.imageCloudfront) {
                    setImg(window.site.common.imageCloudfront)
                }
            }, 1000);
        }
        if (window.site && window.site.common && window.site.common.imageCloudfront) {
            setImg(window.site.common.imageCloudfront)
        }
    }, [])

    const handleViewResult = (id) => {
        setViewresult(true)
        GetQuizInfo(id)
    }
    const handlePageChange = (page) => {
        setCurrentPage(page);
    };
    const GetQuizInfo = async (Id) => {
        try {
            const response = await tmdbApi.quizInfo(Id);
            const allCases = response?.result?.[0]?.cases || [];

            //         setQuizzes(response?.result?.[0]);

            //         // Flatten all answers with their parent case info
            //       const allAnswers = allCases.flatMap(singleCase => {
            //     let correctCount = 0;

            //     return (singleCase.answers || [])
            //         .filter(answer => typeof answer.isCorrect === 'boolean')
            //         .map(answer => {
            //             correctCount++;

            //             return {
            //                 ...answer,
            //                 caseDetails: correctCount === 1 ? singleCase.caseDetails : "",
            //                 adminAnswer:  singleCase.adminAnswer,
            //             };
            //         });
            // });



            setQuizData(allCases);


            setcontentLoaded(true);
        } catch (err) {
            console.log("error", err);
            setcontentLoaded(true);
        }
    };
    const handlePerRowsChange = (newPerPage) => {
        setRowsPerPage(newPerPage);
    };

    const dateDisplay = (date) => {
        const dateObj = new Date(date);

        const formattedIST = dateObj.toLocaleString('en-US', {
            year: 'numeric',
            month: 'short',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: true,
            timeZone: 'Asia/Kolkata'
        });
        return formattedIST;

    }

    // const viewResult = (id) => {

    //     navigate("/result/" + id);

    // }


    const columns = [
        {
            name: 'S NO',
            selector: (row, index) => index + 1
        },
        // {
        //     name: 'Image',
        //     selector: row =>
        //         row?.files?.[0]
        //             ? <div className="myquizimg"> <img src={`${imageCloudfront}${row.files[0].filepath.replace(/ /g, "%20")}?auto=compress,format&width=125`} alt="Row Image" /> </div>
        //             : null,
        // },

        // {
        //     name: 'Quiz Name',
        //     selector: row => parse(row?.quizname) ?? "",
        // },
        // {
        //     name: 'Quiz Type',
        //     selector: (row) => row?.quizType
        // },

        {
            name: 'Participated On',
            selector: row => row?.created,
            cell: (props) => dateDisplay(props?.created),
            sortable: true,
            // sortFunction: (a, b) => moment(a.created).diff(b.created),
        },

        // {
        //     name: 'Score',
        //     selector: row => {
        //         // console.log("Row data:", row); // Debugging: Inspect the row data
        //         const correctAnswers = row?.correctAnswers;
        //         const totalQuestions = row?.totalQuestions;

        //         if (correctAnswers !== undefined && totalQuestions !== undefined) {
        //             return `${correctAnswers}/${totalQuestions}`;
        //         } else {
        //             // console.warn("Missing data for Score:", { correctAnswers, totalQuestions });
        //             return ""; // Fallback for missing data
        //         }
        //     },
        // },
        {
            name: 'Score',
            selector: (row) => row.moduleScore
        },

        {
            name: 'Results',
            cell: (props) => (
                <div className="d-flex align-items-center">
                    {/* Anchor for Result Name */}
                    <a
                        className="text-info action-button me-2" // Add spacing using "me-2" (margin-end)
                        // onClick={() => handleViewResult(props?.learninguniqueid)}
                        onClick={() => handleViewReport(props?.learninguniqueid)}
                        title="View Result"
                    >
                        <i className="mdi mdi-eye font-size-18"></i>
                    </a>


                    {/* Anchor for Summary Name */}

                </div>
            ),
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
        },




    ];


    useEffect(() => {

        if (window.site === undefined) {
            setTimeout(() => {
                if (window.site && window.site.common && window.site.common.imageCloudfront) {
                    setImg(window.site.common.imageCloudfront)
                }
            }, 1000);
        }
        if (window.site && window.site.common && window.site.common.imageCloudfront) {
            setImg(window.site.common.imageCloudfront)
        }


    }, [window.site]);



    // useEffect(() => {
    //     window.scrollTo(0, 0);
    //     let quizinfo = JSON.parse(localStorage.getItem('q'))
    //     if (quizinfo) {
    //         setQuizData(quizinfo)
    //     }
    //     let quizResult = JSON.parse(localStorage.getItem('qr'))
    //     console.log('quizResult', quizResult)
    //     if (quizResult) {
    //         setQuizResultData(quizResult)
    //         setQuizzes(quizResult?.quiz)
    //     }
    //     // GetQuizInfo()
    // }, []);


    useEffect(() => {
        GetHistoryResult()
    }, [])
    const GetHistoryResult = async () => {
        setIsLoading(true)
        try {

            let isThere = state?.moduleType === "FELLOWSHIP"
            const response = await tmdbApi.getHistoryresult(id,isThere);
            const result = response.result.filter(item => item.cases && item.cases.length > 0)?.sort((a, b) => new Date(b.created) - new Date(a.created));
            setQuizzes(result);
            setcontentLoaded(true)
            setIsLoading(false)
        } catch {
            console.log("error");
            setcontentLoaded(true)
        }
    };

    // useEffect(() => {
    //     if (quizData) {
    //         GetQuestionsInfo(quizData)
    //         GetAnswersInfo()
    //     }

    // }, [quizData]);

    const customSort = (rows, selector, direction) => {
        const sortedData = rows.slice().sort((rowA, rowB) => {
            // use the selector function to resolve your field names by passing the sort comparators
            // const aField = selector(rowA);
            const aField = String(selector(rowA)).toLowerCase();

            //  const bField = selector(rowB);
            const bField = String(selector(rowB)).toLowerCase();

            let comparison = 0;

            if (aField > bField) {
                comparison = 1;
            } else if (aField < bField) {
                comparison = -1;
            }

            return direction === 'desc' ? comparison * -1 : comparison;
        });

        // Log the sorted data to the console
        // setSortedRecomData(sortedData)
        global.exportExcelData = sortedData
        // console.log('Sorted Data------>:', sortedData);

        return sortedData;
    };


    const toggleTooltip = (tooltipId) => {
        setActiveTooltip((prev) => (prev === tooltipId ? null : tooltipId));
    };

    const customNoRecords = () => {
        return (

            <div className="empty-state-body empty-record"  >
                <div className="empty-state__message">
                    <span className="material-icons">summarize</span>
                    <p className="form-check font-size-16">No modules submitted yet. Please submit and try again.</p>
                </div> </div>
        )
    }
    const handleReports = () => {
        navigate("/viewreports/");
    }
    const handleViewReport = (value) => {
        navigate("/viewhistory/" + id, {
            state: { learninguniqueid: value,  moduleType: moduleType  }
        });
    };
    const onCancel = () => {
        if(state?.moduleType === "FELLOWSHIP"){
             navigate("/fellowshipmodules");
        }else{
        navigate("/usermoduleslibrary");

        }
    }

    return (
        <div id="layout-wrapper" className="create-case-db">
            <Header />
           <SideMenu />

            {/* Start right Content here  */}

            <div className="main-content user-management create-case history-table" id="main-content">
                <div className="page-content create-case-content" id="page-content">
                    <div className="container-fluid" id="container-fluid">

                        {/* <div className="row mb-4 breadcrumb" id="breadcrumb-row">
                                <div className="col-lg-12">
                                    <div className="d-flex align-items-center">
                                        <div className="flex-grow-1">
                                            <h4 className="mb-2 card-title" id="breadcrumb-title">CASES</h4>
                                        </div>

                                        <div>

                                            <button className="btn btn-primarys create-quiz-btn" onClick={handleAddUser} id="add-user-btn">
                                                CREATE CASE
                                            </button>
                                        </div>


                                    </div>
                                </div>
                            </div> */}

                        <div className="row mb-4 breadcrumb" id="breadcrumb-row">
                            <div className="col-lg-12">
                                <div className="d-flex align-items-center">
                                    <div className="flex-grow-1">
                                        <h4 className="mb-2 card-title" id="breadcrumb-title">
                                            {quizzes?.length > 0 ? quizzes[0]?.modulename : ""}
                                        </h4>

                                    </div>
                                    <div className="create-quiz-btn" onClick={() => onCancel()}>
                                        Back
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row table-data" id="table-data-row">
                            <div className="col-12">
                                <div className="card" id="card">
                                    <div className="card-body" id="card-body">
                                        {isLoading ? <Loader /> : <>
                                            <div className="row mb-2" id="table-header-row">
                                                <div className="col-sm-4 button-block" id="button-block">
                                                    <div className="dataTables_length" id="datatable-length">

                                                        {/* <button className={`fill_btn ${data.length <= 0 ||subValDashboard.export.enable === false ? 'disable pe-none' : ''}`} 
                          onClick={handleExport} id="export-btn">
                          <span className="material-icons">north_east</span>Export
                      </button> */}


                                                    </div>
                                                </div>
                                                {/* <div className="col-sm-8">
                                                    <div className="search-box mb-2 d-inline-block" id="search-box">
                                                        <div className="position-relative">
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                value={usersearch}
                                                                onChange={(e) => handleChange(e)}
                                                                placeholder="Search by Case Diagnosis"
                                                                onKeyPress={handleKeypress}
                                                                id="search-input"
                                                            />
                                                            <button
                                                                className="fill_btn"
                                                                onClick={(e) => handleSearch(e, "normalsearch")}
                                                                id="search-btn">
                                                                <span className="material-icons search-icon">search</span>
                                                            </button>
                                                        </div>
                                                        <div className="dataTables_length" id="datatable-length-reset">
                                                            <button
                                                                className="fill_btn"
                                                                onClick={clearSearch}
                                                                id="reset-btn">
                                                                <span className="material-icons-outlined">sync</span>Reset
                                                            </button>
                                                        </div>
                                                    </div>
                                                    <div className="text-sm-end" id="text-end"></div>
                                                </div> */}
                                            </div>
                                         

                                            <DataTable
                                                key={keyForRerender}
                                                columns={columns}
                                                keyField='_id'
                                                data={quizzes}
                                                direction="auto"
                                                highlightOnHover
                                                fixedHeaderScrollHeight="300px"
                                                pagination
                                                responsive
                                                persistTableHead
                                                striped
                                                subHeaderAlign="right"
                                                defaultSortField="name"
                                                noDataComponent={customNoRecords()}
                                                paginationTotalRows={quizzes?.length}
                                                onChangeRowsPerPage={handlePerRowsChange}
                                                onChangePage={handlePageChange}
                                                paginationPerPage={rowsPerPage}
                                                paginationDefaultPage={currentPageNew}
                                                paginationRowsPerPageOptions={[15, 25, 50, 75, 100]}
                                                sortFunction={customSort}
                                                paginationComponentOptions={{
                                                    rowsPerPageText: 'Per page:',
                                                    rangeSeparatorText: 'of',
                                                    noRowsPerPage: false,
                                                    selectAllRowsItem: false,
                                                    selectAllRowsItemText: 'All',
                                                }}
                                                // progressPending={isLoading}
                                                // progressComponent={<Loader />}
                                                id="data-table"
                                            />

                                        </>}

                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

                {/* <SweetAlert
                        show={tableErrMsg}
                        custom
                        confirmBtnText="ok"
                        confirmBtnBsStyle="primary"
                        title={"Something went wrong. Please reload again."}
                        onConfirm={e => setTableErrMsg(false)}
                        id="error-alert"
                    ></SweetAlert>


                    <SweetAlert
                        show={deleteShow}
                        warning
                        showCancel
                        confirmBtnText="Yes"
                        cancelBtnText="Cancel"
                        confirmBtnBsStyle="danger"
                        cancelBtnBsStyle="default"
                        title="Are you sure you want to delete?"
                        focusCancelBtn
                        onConfirm={e => handleDelete(e)}
                        onCancel={e => onDeleteCancel(e)}
                    >
                    </SweetAlert>

                    <SweetAlert show={deleteSuccess}
                        custom
                        confirmBtnText="ok"
                        confirmBtnBsStyle="primary"
                        title={"Deleted Successfully"}
                        onConfirm={e => onDeletePopupClose(e)}
                    >
                    </SweetAlert> */}

                <Modal className="completedCpcTable" show={viewResult} >

                    <div className="modal-body enquiry-form">
                        <div className="container">
                            <button className="close-btn" onClick={e => setViewresult(false)}><span className="material-icons">close</span></button>

                            <table className="table align-middle table-nowrap mb-0 case-answers-table history-popup-table" id="quiz-table-cpc" style={{ tableLayout: 'fixed', width: '100%' }}>
                               
                                <tbody>
                                    <>
                                        {quizData?.map((caseData, index) => (
                                            <React.Fragment key={index}>
                                                <tr className="bg-light">
                                                    <th>Case {index + 1}</th>
                                                    {/* <th>Description</th> */}
                                                    <th>Answer</th>
                                                </tr>

                                                {caseData?.answers
                                                    ?.filter((answer) => answer.hasOwnProperty("isCorrect"))
                                                    .map((answer, ansIndex) => {
                                                        const tooltipId = `tooltip-${index}-${ansIndex}`;

                                                        return (
                                                            <tr key={ansIndex}>
                                                            
                                                                <td>
                                                                    {caseData?.caseDetails?.clinicalhistory
                                                                        ?.replace(/<[^>]+>/g, "") // remove tags
                                                                        ?.replace(/&[^;]+;/g, " ")} {/* remove entities like &nbsp; &amp; etc */}
                                                                </td>


                                                                {answer?.isCorrect ? (
                                                                    <td className="history-answer-data"><span className="history-answer">{answer.answer}</span></td>
                                                                ) : (
                                                                    <td
                                                                        className="history-wrong-answer"
                                                                        style={{
                                                                            position: "relative",
                                                                            zIndex: 1,
                                                                            overflow: "visible",
                                                                        }}
                                                                    >
                                                                        <span>{answer?.answer}</span> (
                                                                        <span
                                                                            className="tooltip-correct-answer"
                                                                    
                                                                        >
                                                                            {" " + caseData.adminAnswer + " "}
                                                                        </span>
                                                                    
                                                                        )
                                                                    </td>
                                                                )}
                                                            </tr>
                                                        );
                                                    })}
                                            </React.Fragment>
                                        ))}
                                    </>
                                </tbody>

                            </table>

                        </div>
                    </div>

                </Modal>
                <Footer id="footer" />
            </div>





        </div>
    );
};

export default History;
